import { app } from '../../../../../app';
import { Controller } from './add-shared-note.controller';

app.component('companySharingCenterSharedNotesAdd', {
	bindings: {
		companyId:'<'
	},
    controller: Controller,
    templateUrl: require('./add-shared-note.html'),
});


// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-notes/add/add-shared-note.component.js